import styled from 'styled-components';
import materialUI from '../../material-UI';

export const Accordion = styled(materialUI.Accordion)``;
export const AccordionSummary = styled(materialUI.AccordionSummary)``;
export const AccordionDetails = styled(materialUI.AccordionDetails)``;
export const Img = styled.img``;
export const Divider = styled(materialUI.Divider)`
  width: 110%;
  margin-right: 10px;
`;
